import { useTheme } from "styled-components"
import { SearchIcon } from "@images/svgIcons/searchIcon"
import { InputText } from "primereact/inputtext"
import { CrossIcon } from "@images/svgIcons/crossIcon"
import { word } from "@modules/core/utils/i18n"

export type HuSearchBarProps = {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  placeholder?: string
} & React.HTMLAttributes<HTMLDivElement>

export const HuSearchBar: React.FC<HuSearchBarProps> = ({ searchTerm, setSearchTerm, placeholder, ...props }) => {
  const theme = useTheme()
  const defaultClassName = "flex w-full mb-5"

  const clearSearch = () => {
    setSearchTerm("")
  }

  return (
    <div className={props.className ? props.className : defaultClassName} {...props}>
      <div className=" flex align-items-center w-full h-3rem rounded-full border-1 border-neutral-300">
        <div className="flex flex-grow-1 align-items-center">
          <div className="flex align-items-center justify-content-center w-3rem h-full p-0">
            <SearchIcon color={theme.neutralColor700} width={14} height={14} />
          </div>
          <InputText
            className={`flex flex-grow-1 h-full p-0 m-0 border-none outline-none ${searchTerm ? "" : "mr-3"}`}
            placeholder={placeholder ? placeholder : word("boxSessionAddSubscriberModal.dialog.inputText")}
            value={searchTerm}
            style={{ borderRadius: "0px" }}
            onChange={(e) => setSearchTerm(e.currentTarget.value)}
          />
        </div>
        {searchTerm && (
          <button onClick={clearSearch} className="flex align-items-center justify-content-center w-3rem h-full ">
            <CrossIcon color={theme.neutralColor700} width={14} height={14} />
          </button>
        )}
      </div>
    </div>
  )
}
